import { print } from 'graphql';
import { gql } from 'graphql-tag';
import type { MigrationStrategies, RxCollection, RxDocument, RxJsonSchema } from 'rxdb';

import { getDateModified } from '../../utilities/utilityFunctions';
import { getValueFromLocalStorage } from '../share/defaultDoc';

export interface Notification {
  readonly pkUSerAlertId: string;
  readonly alertNotificationId: number;
  readonly userId: number;
  readonly alertText: string;
  readonly isRead: boolean;
  readonly isMobileAlert: boolean;
  readonly createdBy: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly roleId: number;
  readonly site: number;
  readonly discipline: number;
  readonly datecreated: string;
  readonly isActive: boolean;
  readonly alertMetaData: string;
}

export const notificationSchema: RxJsonSchema<Notification> = {
  type: 'object',
  version: 1,
  description: 'describes work package',
  primaryKey: 'pkUSerAlertId',
  properties: {
    pkUSerAlertId: { type: 'string', maxLength: 36 },
    alertNotificationId: { type: ['number', 'null'] },
    userId: { type: ['number', 'null'] },
    alertText: { type: ['string', 'null'] },
    isRead: { type: ['boolean', 'null'] },
    isMobileAlert: { type: ['boolean', 'null'] },
    createdBy: { type: ['string', 'null'] },
    firstName: { type: ['string', 'null'] },
    lastName: { type: ['string', 'null'] },
    roleId: { type: ['number', 'null'] },
    site: { type: ['number', 'null'] },
    discipline: { type: ['number', 'null'] },
    datecreated: { type: ['string', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    alertMetaData: { type: ['string', 'null'] },
  },
};

export const notificationMigrationStrategies: MigrationStrategies = {
  1: (oldDoc: NotificationDocument) => ({ ...oldDoc, isActive: true, alertMetaData: '' }),
};

export type NotificationCollection = RxCollection<Notification> | null;
export type NotificationDocument = RxDocument<Notification>;

export const notificationPullQueryBuilder = (document: Notification) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { datecreated: '1900-01-01T01:01:01.1234567-06:00' };
  }
  const query = print(gql`
    query mobileAlertNotifications($siteId: Int!, $disciplineId: Int!, $lastRequested: DateTime!) {
      mobileAlertNotifications(
        siteId: $siteId
        disciplineId: $disciplineId
        lastRequested: $lastRequested
      ) {
        pkUSerAlertId
        alertNotificationId
        userId
        alertText
        isRead
        isMobileAlert
        createdBy
        firstName
        lastName
        roleId
        site
        discipline
        datecreated
        isActive
        alertMetaData
      }
    }
  `);
  return {
    query,
    variables: {
      siteId: JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
      disciplineId: JSON.parse(getValueFromLocalStorage('selectedDiscipline'))
        ?.selectedDisciplineId,
      lastRequested: getDateModified(
        null,
        doc?.datecreated,
        doc.site,
        doc.discipline,
        JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
      ),
    },
  };
};

export const notificationPushQueryBuilder = (doc: NotificationDocument[]) => {
  const query = doc[0].isActive
    ? print(gql`
        mutation mobileMarkAlertAsRead($alerts: [Int]!) {
          mobileMarkAlertAsRead(alerts: $alerts)
        }
      `)
    : print(gql`
        mutation mobileMarkAlertAsDisabled($alerts: [Int]!) {
          mobileMarkAlertAsDisabled(alerts: $alerts)
        }
      `);
  const variables = {
    alerts: [doc[0].alertNotificationId],
  };
  return {
    query,
    variables,
  };
};

export default {};
